export default __webpack_public_path__ + "static/media/Inter-UI-ExtraBoldItalic.44456f17.woff2";